<template>
  <section v-if="showAttachments"
           class="section is-paddingless">
    <section v-if="total">
      <virtual-list :data-component="VirtualScrollCards"
                    :data-sources="attachments"
                    :extra-props="{ isWidget }"
                    class="vs-card-list"
                    data-key="id"
                    @tobottom="getMoreAttachments">
        <template #footer>
          <utility-block v-show="isLoading"/>
        </template>
      </virtual-list>
    </section>
    <section v-else-if="!total" class="no-data py-4">
      <h1 data-int="attachments-no-data" class="subtitle has-text-centered">
        {{ $t('assetsNotFound', { type: $tc('attachment', 2) }) }}
      </h1>
    </section>
  </section>
</template>

<script setup lang="ts">
import { computed, provide, toRaw, watch, onBeforeMount } from "vue"
import { useStore } from "vuex"
//@ts-ignore
import VirtualList from "vue3-virtual-scroll-list"

import VirtualScrollCards from "@/components/common/VirtualScrollCards.vue"
import UtilityBlock from "@/components/common/UtilityBlock.vue"

import useDetailPage from "@/components/library/content/details/useDetailPage"
import { downloadOnClick } from "@/helpers/download"
import { useBreakpoints } from '@/helpers/responsiveBreakpoints'

provide("eventHandlers", { select, navToWidgetContent })

const store = useStore()
const { showAttachments } = useDetailPage()
const { outerWidth } = useBreakpoints()

const isWidget = computed(() => store.getters['widgets/isWidget'])
const isIframe = window.top !== window.self

const contentLoaded = computed(() => store.state.content.isLoaded)
const isMobile = computed(() => {
  return outerWidth.value <= 768
})
const attachments = computed(() => {
  if (isMobile.value) {
    return store.getters["content/attachmentsAsMatrixMobile"]
  }
  return store.getters["content/attachmentsMatrix"]
})
const isLoading = computed(() => {
  return store.state.content.attachments.loading
})
const total = computed(() => {
  return store.state.content.attachments.total
})

async function getAttachments() {
  await store.dispatch("content/getAttachments")
}
async function navToWidgetContent(content: any) {
  await select(content)
}
async function select(content: any) {
  const dto = toRaw(content)
  const isRelatedMedia = dto.type === "media"
  const isFile = Object.hasOwn(dto, 'contentUrl')
    && Object.hasOwn(dto, 'name')
    && !Object.hasOwn(dto, 'type')

  if (isRelatedMedia) {
    store.dispatch("content/navigateToContent", { content })
  } else if (isFile) {
    await downloadOnClick(dto.contentUrl, dto.name, !isIframe)
  }
}

async function getMoreAttachments() {
  await store.dispatch("content/getMoreAttachments")
}

onBeforeMount(async () => {
  if (store.state.content.attachments.items.length === 0) {
    await getAttachments()
  }
})
watch(contentLoaded, async (value: boolean) => {
  if (value) {
    await getAttachments()
  }
})
</script>

<style lang="scss" scoped>
.no-data {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
}
</style>
